/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MeasurementConfiguration
 */
export interface MeasurementConfiguration {
  /**
   *
   * @type {string}
   * @memberof MeasurementConfiguration
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof MeasurementConfiguration
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof MeasurementConfiguration
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof MeasurementConfiguration
   */
  measurementConfigurationId: string;
  /**
   *
   * @type {object}
   * @memberof MeasurementConfiguration
   */
  measurementPair?: object | null;
  /**
   *
   * @type {object}
   * @memberof MeasurementConfiguration
   */
  currentPair?: object | null;
  /**
   *
   * @type {string}
   * @memberof MeasurementConfiguration
   */
  frd: string;
  /**
   *
   * @type {string}
   * @memberof MeasurementConfiguration
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the MeasurementConfiguration interface.
 */
export function instanceOfMeasurementConfiguration(
  value: object
): value is MeasurementConfiguration {
  if (
    (!("measurementConfigurationId" in (value as Record<string, any>)) &&
      !("measurement_configuration_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["measurementConfigurationId"] === undefined &&
      (value as Record<string, any>)["measurement_configuration_id"] === undefined)
  )
    return false;
  if (!("frd" in value) || value["frd"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function MeasurementConfigurationFromJSON(json: any): MeasurementConfiguration {
  return MeasurementConfigurationFromJSONTyped(json, false);
}

export function MeasurementConfigurationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MeasurementConfiguration {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    measurementConfigurationId: json["measurement_configuration_id"],
    measurementPair:
      json["measurement_pair"] === undefined
        ? undefined
        : json["measurement_pair"] === null
        ? null
        : json["measurement_pair"],
    currentPair:
      json["current_pair"] === undefined
        ? undefined
        : json["current_pair"] === null
        ? null
        : json["current_pair"],
    frd: json["frd"],
    dataOwner: json["data_owner"],
  };
}

export function MeasurementConfigurationToJSON(json: any): MeasurementConfiguration {
  return MeasurementConfigurationToJSONTyped(json, false);
}

export function MeasurementConfigurationToJSONTyped(
  value?: Omit<MeasurementConfiguration, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    measurement_configuration_id: value["measurementConfigurationId"],
    measurement_pair: value["measurementPair"],
    current_pair: value["currentPair"],
    frd: value["frd"],
    data_owner: value["dataOwner"],
  };
}
